<template>
  <div class="image-custom">
    <!-- <el-tooltip :content="tips" placement="top"> -->
      <!-- 未选择图片 -->
      <div
        class="image-box"
        :style="{ width: `${width}px`, height: `${height}px` }"
        v-if="!imgUrl"
      >
        <!-- <img :src="imgUrl" alt /> -->
        <div @click="handleSelectImage" class="update-box">
          <i class="el-icon-plus"></i>
          <div class="txt">上传图片</div>
        </div>
        <!-- <div class="update-box-black"></div> -->
        <!-- <div class="uodate-repalce" @click="handleSelectImage">选择</div> -->
      </div>
      <!-- 已选择图片 -->
      <div @click="handleSelectImage" v-else>
        <img style="object-fit: cover;" :src="imgUrl" alt="" :width="width||'55px'" :height="height||'55px'" />
      </div>
    <!-- </el-tooltip> -->
    <!-- 文件选择器 -->
    <!-- <FilesModal ref="FilesModal" :multiple="false" @handleSubmit="handleSelectImageSubmit" /> -->
    <xsk-manage-weishop
      :managehide.sync="imgplugin.show"
      @confirm="imgpluginFun"
      :multiple="imgplugin.multiple"
      :count="imgplugin.count"
      is_rest
    >
    </xsk-manage-weishop>
  </div>
</template>

<script>
// import PropTypes from 'ant-design-vue/es/_util/vue-types'
// import { FilesModal } from '@/components/Modal'

// 图片选择器组件
export default {
  name: "SImage",
  components: {
    // FilesModal
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    // 默认显示的图片
    value: "",
    // 气泡提示内容
    tips: "",
    // 元素的尺寸(宽)
    width: {
		type: Number, // 根据你传递的类型，修改这里的类型
				default: 80
	},
    // 元素的尺寸(高)
    height: {
		type: Number, // 根据你传递的类型，修改这里的类型
				default: 80
	}
  },
  data() {
    return {
      // 选择的图片
      imgUrl: "",
      imgplugin: {
        show: false,
        multiple: false,
        count: 1,
        imgName: "",
      },
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler(val) {
        this.imgUrl = val;
      },
    },
  },
  created() {},
  methods: {
    // 素材库回调
    imgpluginFun(obj) {
      this.onChange(obj.imgobjs[0]);
    },

    // 打开文件选择器
    handleSelectImage() {
      let _this = this;
      _this.imgplugin.show = true;
      // this.$refs.FilesModal.show()
    },

    // 文件库modal确认回调
    handleSelectImageSubmit(result) {
      if (result.length > 0) {
        const file = result[0];
        this.onChange(file);
      }
    },

    // 触发change事件
    onChange(file) {
      // 记录imgUrl
      this.imgUrl = file.base_url;
      // v-model
      this.$emit("change", this.imgUrl);
      // 触发update事件
      this.$emit("update", file);
    },
  },
};
</script>

<style lang="less" scoped>
.image-custom {
  display: flex;
  align-items: center;

  .image-box {
    position: relative;
    width: 80px;
    height: 80px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    // background-image: url('~@/assets/img/default-image.png');
    background: #fff;
    background-size: cover;
    overflow: hidden;
    border: 1px solid #f4f4f4;
    border-radius: 2px;

    .update-box-black {
      background: #000;
      opacity: 0.5;
      display: none;
      position: absolute;
      z-index: 2;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      border-radius: 2px;
    }

    .uodate-repalce {
      width: 60px;
      height: 30px;
      font-size: 12px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      display: none;
      z-index: 2;
      background: #fff;
      border-radius: 2px;
      font-weight: 600;
      color: #595961;
      line-height: 30px;
    }

    &:hover {
      .update-box-black,
      .uodate-repalce {
        display: block;
      }
    }

    img {
      width: 100%;
      height: auto;
      // height: 100%;
      // object-fit: cover;
      border-radius: 2px;
    }
  }
}
.update-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #006aff;
  i {
    font-size: 20px;
  }
  .txt {
    margin-top: 5px;
    color: #b8b9bd;
  }
}
</style>
